export default __webpack_public_path__ + "static/media/cx.7ad5919c.svg";